var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JobList',{attrs:{"isMSDCustom":"","company":_vm.companyInfo}})
}
var staticRenderFns = []

export { render, staticRenderFns }